<script>
import NewMaterialItem from '@/components/new-material-item.vue'
export default {
  name: 'new-material-item-list',
  components: {
    NewMaterialItem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    noDataText: {
      type: String,
      default: () => 'No items found.',
    },
  },
  data: () => ({}),
  computed: {
    itemsDisplayed() {
      //TODO: Probably move to mixin
      if (!this.items?.length) return []
      return this.items
        .map((item) => {
          const isExpandable = item?.description?.length >= 300
          const author = this.getAuthor(item)
          return {
            author,
            authorCatalogUrl: this.getAuthorCatalogUrl(author),
            description: item.description || '',
            descriptionShort: isExpandable
              ? `${item.description.substring(0, 300)}...`
              : item.description || '',
            isExpandable,
            publishing: this.getPublishing(item),
            thumbnail: this.getThumbnail(item),
            title: item.title,
            titleCatalogUrl: this.getTitleCatalogUrl(item),
          }
        })
        ?.sort((a, b) => a.title.localeCompare(b.title))
      // return this.items
    },
  },
  methods: {
    getAuthor(item) {
      let author = ''
      if (item?.authors) {
        //If array of Authors (expected) conform to Last, First format
        if (Array.isArray(item.authors)) {
          author = item.authors
            .map((author) => {
              return author.includes(', ')
                ? author
                : author.split(' ').reverse().join(', ')
            })
            .join('; ')
        }
      }
      return author
    },
    getAuthorCatalogUrl(author) {
      //TODO: replace missing with catalog keyword search
      // https://search.livebrary.com/search/?searchtype=a&SORT=D&searcharg=king%2C+stephen&searchscope=20
      const searchArg = author.replaceAll(', ', '+')
      return `https://search.livebrary.com/search/?searchtype=a&SORT=D&searcharg=${searchArg}&searchscope=20`
    },
    getPublishing(item) {
      let publishing = ''
      const publishedDate = item?.publishedDate?.split('-')[0] || ''
      publishing += item.publisher || ''
      publishing += `${publishing.length > 1 ? ', ' : ''}${publishedDate || ''}`
      return publishing
    },
    getThumbnail(item) {
      const ImgFallback =
        'https://media.eipl.org/site/images/logos/eipl-square.jpg'
      let src =
        item?.imageLinks?.thumbnail ||
        item?.imageLinks?.smallThumbnail ||
        ImgFallback
      src = src.replaceAll('Type=S', 'Type=M')
      //todo: set default..
      return src
    },
    getTitleCatalogUrl(item) {
      //TODO: replace missing with catalog keyword search
      return item.catalogUrl || '#'
    },
  },
  created() {},
}
</script>

<template>
  <v-sheet
    color="transparent"
    class="d-flex flex-column align-center justify-center"
  >
    <p
      v-if="!itemsDisplayed?.length"
      class="d-span text-center primary--text font-weight-bold secondary rounded-pill py-4 px-8"
    >
      {{ noDataText }}
    </p>
    <new-material-item
      v-for="item in itemsDisplayed"
      :key="item.id"
      :item="item"
    ></new-material-item>
  </v-sheet>
</template>

<style scoped></style>
